import actionTypes from '../types/dashboardTypes';

export const setPbiDashboardData = (payload: any): any => ({
    type: actionTypes.SET_PBI_DASHBOARD_DATA,
    payload: payload,
})

export const setDashboardFilter = (dashboardFilter: any, dashboardType: string): any => ({
    type: actionTypes.SET_DASHBOARD_FILTER,
    payload: { dashboardFilter, dashboardType },
});

export const logout = (): any => ({
    type: actionTypes.LOGOUT,
})